import { HTMLAttributes, useRef, useState } from 'react';
import { useResizeObserver } from 'hooks/useResizeObserver';

/**
 * A hook to check scroll size of target element to define tabIndex / aria role props
 */
export function useScrollableElement<T extends HTMLElement>(vect: 'x' | 'y') {
  const [isScrollable, setIsScrollable] = useState(false);
  const targetRef = useRef<T>(null);
  const isHorizontal = vect === 'x';

  useResizeObserver({
    targetRef,
    callback: () => {
      setIsScrollable(prev => {
        const target = targetRef.current;
        if (!target) return prev;
        const scrollable = isHorizontal
          ? target.offsetWidth < target.scrollWidth
          : target.offsetHeight < target.scrollHeight;
        return scrollable;
      });
    },
  });

  const attr: HTMLAttributes<T> = isScrollable
    ? {
        'aria-orientation': isHorizontal ? 'horizontal' : 'vertical',
        role: 'scrollbar',
        tabIndex: 0,
      }
    : {};

  return { ...attr, ref: targetRef };
}
